import { useMediaQuery, useTheme } from '@mui/material'

export function useIsLargeScreen() {
  const theme = useTheme()
  const isLargeScreen = useMediaQuery(theme.breakpoints.up('xl'), { noSsr: true })
  return isLargeScreen
}
